import { MonitorSmartphone } from "lucide-react";

export function DeviceBar({ padId }: { padId: string }) {
  return (
    <footer className="flex min-h-14 min-w-0 flex-col gap-2 bg-white px-4 py-3 text-sm text-neutral-500 sm:flex-row sm:items-center lg:px-6">
      <div className="flex min-w-0 items-center gap-2">
        <MonitorSmartphone size={18} />
        <span className="truncate">
          {padId === "public" ? "Public Slip" : `Shared Slip ${padId}`} works from any device with this link.
        </span>
      </div>
      <span className="flex-1" />
      <span>{window.location.host || "s.kuizuo.me"}</span>
    </footer>
  );
}
